import React from "react";
import { Chip, Tooltip, Badge, IconButton } from "@mui/material";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { alpha } from "@mui/material/styles";

// Resuelve el registro de seguimiento del cliente activo (o el primero con estado)
const resolveInfo = (seguimientoInfo, idCliente) => {
  const lista = Array.isArray(seguimientoInfo) ? seguimientoInfo : [];
  if (idCliente) return lista.find((s) => s.clienteId === idCliente) || null;
  return lista.find((s) => s.estadoId) || lista[0] || null;
};

// Solo el chip de estado. El texto se trunca dentro del chip, nunca desborda la celda.
export const SeguimientoBadge = ({ seguimientoInfo, idCliente = null, onClick = null }) => {
  const info = resolveInfo(seguimientoInfo, idCliente);

  const handleClick = (e) => {
    if (!onClick) return;
    e.stopPropagation();
    onClick();
  };

  if (!info || !info.estadoId) {
    return (
      <Chip
        size="small"
        variant="outlined"
        label="Sin seguimiento"
        onClick={onClick ? handleClick : undefined}
        sx={{
          maxWidth: "100%",
          color: "text.disabled",
          borderColor: "divider",
          fontSize: "0.72rem",
          cursor: onClick ? "pointer" : "default",
          "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
          "&:hover": onClick ? { borderColor: "primary.main", color: "primary.main" } : undefined,
        }}
      />
    );
  }

  const color = info.estadoColor || "#9E9E9E";

  return (
    <Tooltip title={info.estadoNombre || ""}>
      <Chip
        size="small"
        label={info.estadoNombre}
        onClick={onClick ? handleClick : undefined}
        sx={{
          maxWidth: "100%",
          bgcolor: alpha(color, 0.15),
          color,
          fontWeight: 600,
          border: `1px solid ${alpha(color, 0.4)}`,
          fontSize: "0.72rem",
          cursor: onClick ? "pointer" : "default",
          "& .MuiChip-label": { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
        }}
      />
    </Tooltip>
  );
};

// Botón de acción de seguimiento con el número de observaciones como badge encima del icono.
export const SeguimientoAccionButton = ({ seguimientoInfo, idCliente = null, onClick }) => {
  const info = resolveInfo(seguimientoInfo, idCliente);
  const obs = info?.cantidadObservaciones || 0;

  const handleClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  const titulo = obs > 0
    ? `Seguimiento · ${obs} observación${obs === 1 ? "" : "es"}`
    : "Seguimiento";

  return (
    <Tooltip title={titulo}>
      <IconButton size="small" color="primary" onClick={handleClick}>
        <Badge
          badgeContent={obs}
          color="error"
          sx={{ "& .MuiBadge-badge": { fontSize: "0.6rem", height: 16, minWidth: 16 } }}
        >
          <ChatBubbleOutlineIcon fontSize="small" />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default SeguimientoBadge;